'use client';

import useMicroFrontend from '@/common/MicroFrontEnds';

type OwnProps = {
  debug: boolean;
};

/**
 * Client Component for MicroFrontend initialization
 * Used by MicroFrontendInitializer server component
 */
export default function MicroFrontendClient({ debug }: OwnProps) {
  useMicroFrontend(debug);

  return null;
}
